import React from "react";
import { Link } from "react-router-dom";
import { TYPE_VOUCHER_ADULT } from "@config/config";
import BookingDetails from "@components/Bookings/BookingDetails";
import StarIcon from "@components/Icons/StarIcon";
import MoviePoster from "@components/MoviePoster";
import SessionDetails from "@components/SessionDetails";
import TicketClarification from "@components/Tickets/TicketClarification";
import VoucherList from "@components/VoucherList";


const TicketingConfirmation = ({
                                   user,
                                   purchasedSession,
                                   purchasedTicket,
                                   lastPurchase,
                                   tempAccountCreation,
                                   isBypassActive,
                                   isGuestExperienceEnabled,
                                   hideProfileMenu,
                               }) => {
    const showOrdersLink = !isGuestExperienceEnabled && hideProfileMenu !== true;
    
    return (
        <div className="confirmation">
            <div className="confirmation__header">
                <div className="confirmation__details">
                    <h1 className="confirmation__title">
                        Congratulations{user?.first_name ? ` ${user.first_name}` : ""}! You&apos;re off to the movies!
                    </h1>
                    <p className="paragraph">
                        You should already have received an email with details of your purchase.
                    </p>

                    {tempAccountCreation && !isBypassActive && (
                        <p className="paragraph">
                            A secondary email will be sent to complete the account creation process.
                        </p>
                    )}

                    {purchasedSession?.ticket_type_id === TYPE_VOUCHER_ADULT && (
                        <>
                            <TicketClarification />
                            {purchasedTicket?.booking_url && (
                                <p className="paragraph">
                                    Click{" "}
                                    <a
                                        className="link"
                                        href={purchasedTicket.booking_url}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        here
                                    </a>{" "}
                                    to confirm your seat, please note cinema booking fees may apply.
                                </p>
                            )}
                        </>
                    )}
                </div>
            </div>

            <div className="confirmation__body">
                {purchasedSession && (
                    <div className="confirmation__image">
                        <MoviePoster movie={purchasedSession} size="medium" />
                    </div>
                )}

                <div className="confirmation__details">
                    {purchasedSession && <SessionDetails session={purchasedSession} />}
                    {purchasedTicket && (
                        <div className="confirmation__movie-price-details">
                            <BookingDetails ticket={purchasedTicket} session={purchasedSession} />
                        </div>
                    )}
                </div>

                <div className="confirmation__buttons">
                    {showOrdersLink ? (
                        <Link to="/user/current-tickets" className="button button__primary">
                            <StarIcon />
                            View My Orders
                        </Link>
                    ) : (
                        <GuestCodeDisplay lastPurchase={lastPurchase} />
                    )}
                </div>
            </div>
        </div>
    );
};


const GuestCodeDisplay = ({ lastPurchase }) => {
    const hasVoucherUrls =
        lastPurchase?.vouchers?.length > 0 &&
        lastPurchase.vouchers.some((v) => v.voucher_code_url);

    if (hasVoucherUrls) {
        return (
            <div className="confirmation__list">
                <VoucherList vouchers={lastPurchase.vouchers} />
            </div>
        );
    }

    if (lastPurchase?.qr_code_url) {
        return (
            <div className="confirmation__code">
                <img className="img confirmation__img" alt="QR code" src={lastPurchase.qr_code_url} />
            </div>
        );
    }

    if (lastPurchase?.bar_code_url) {
        return (
            <div className="confirmation__code">
                <img className="img confirmation__img" alt="Barcode" src={lastPurchase.bar_code_url} />
            </div>
        );
    }

    return null;
};

export default TicketingConfirmation;
